<ng-container>
  <ng-container *ngIf="pages.length != 0">
    <ul class="pager">
      <a class="arrow prev" href="javascript:;" (click)="move(-1)" *ngIf="page != 1">
        <i aria-hidden="true" class="fa fa-chevron-left"></i>
      </a>
      <div id="page-label">Page:</div>
      <li class="page-item" [class.current]="page == p" *ngFor="let p of pages">
        <a (click)="clicked(p)" href="javascript:;" *ngIf="p != null">{{ p | number }}</a>
        <a *ngIf="p == null">...</a>
      </li>
      <a class="arrow next" href="javascript:;" (click)="move(1)" *ngIf="page != totalPages">
        <i aria-hidden="true" class="fa fa-chevron-right"></i>
      </a>
    </ul>
  </ng-container>
</ng-container>
